export enum ResearchCategoryID {
    ShortTerm = 4,
    MostTraded = 7,
    TurboTrader = 20
}
